import React from 'react';
import { Text, View, StyleSheet, TouchableOpacity } from 'react-native';
import {
  Icon,
  Heading,
  HeadingTypes,
} from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const styles = StyleSheet.create({
  formHeader: {
    borderTopWidth: defaultScale(0.5),
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Theme.WHITE,
    justifyContent: 'space-between',
    borderTopColor: Theme.GREY_MEDIUM_LIGHT,
  },
  formHeaderBorderBottom: {
    borderBottomWidth: defaultScale(0.5),
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
  },
  formTitle: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.GREY_DARK_MEDIUM,
  },
  tittleContainer: {
    flexDirection: 'column',
    paddingVertical: defaultScale(20),
  },
  subHeading:{
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.GREY_DARK_MEDIUM,
  }
});

const AccordingHeader = ({
  index,
  section,
  isActive,
  setActiveIndex,
  onPress = () => {},
  headingStyle = {},
  subHeadingStyle = {},
  titleContainerStyle,
}) => (
  <TouchableOpacity
    onPress={() => {
      if (isActive) {
        setActiveIndex(false);
      } else {
        setActiveIndex(index);
      }
      onPress();
    }}
    style={[
      styles.formHeader,
      (section.isLast && !isActive) && styles.formHeaderBorderBottom]}> 
      <View style={[styles.tittleContainer, titleContainerStyle]}>
        <Heading
          title={section.title}
          style={[styles.formTitle, headingStyle]}
          headingType={HeadingTypes.HEADING_TWO}
        />
        {section.subHeading && (
          <Text style={[styles.subHeading, subHeadingStyle]}>{section.subHeading}</Text>
        )}
      </View>
    <Icon
      size={defaultScale(25)}
      color={Theme.GREY_DARK_MEDIUM}
      name={isActive ? 'ios-arrow-up' : 'ios-arrow-down'}
    />
  </TouchableOpacity>
);

export default AccordingHeader;
